import React, { useEffect } from 'react';
import {
  AuthenticatedTemplate,
  MsalProvider,
  MsalAuthenticationTemplate,
} from '@azure/msal-react';
import { InteractionType, PublicClientApplication } from '@azure/msal-browser';
import { useDispatch, useSelector } from 'react-redux';
import { loginRequest, msalConfigCreator } from './services/users/authConfig';
import App from './App';
import { fetchSettings } from './store/settings/actions';

import AuthInstanceWrapper from './AuthInstanceWrapper';

/**
 * This component creates the msal instance, of which there may only be one
 * in existence.
 */
const AuthWrapper = (): JSX.Element | null => {
  const dispatch = useDispatch();
  const settings = useSelector((state: any) => state.settings.settings);

  useEffect(() => {
    if (!settings) {
      dispatch(fetchSettings());
    }
  }, [dispatch, settings]);

  if (!settings) {
    return null;
  }

  const msalConfig = msalConfigCreator(settings);
  const msalInstance = new PublicClientApplication(msalConfig);

  return (
    <MsalProvider instance={msalInstance}>
      <MsalAuthenticationTemplate
        interactionType={InteractionType.Redirect}
        authenticationRequest={loginRequest}
      >
        <AuthInstanceWrapper>
          <AuthenticatedTemplate>
            <App />
          </AuthenticatedTemplate>
        </AuthInstanceWrapper>
      </MsalAuthenticationTemplate>
    </MsalProvider>
  );
};

export default AuthWrapper;
